
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-product-demo-a",
      function () {
        return require("private-next-pages/new-product-demo-a/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-product-demo-a"])
      });
    }
  